<template>
	<div class="toolbar flex align-center justify-space-between">
		<div class="box-left box grow flex">
			<button @click="toggleSidebar" v-if="menuBurger !== 'right'" class="toggle-sidebar card-base card-shadow--small">
				<i class="mdi mdi-menu"></i>
			</button>

			<!-- <search class="hidden-xs-only" v-if="isAdmin"></search> -->
		</div>
		<div class="box-right flex align-center pl-10">
			<el-dropdown trigger="click" @command="onCommandLang">
				<span class="el-dropdown-link">
					<i class="flag-icon" :class="{['flag-icon-'+flag]:true}"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="en-US"><i class="flag-icon flag-icon-us mr-15"></i>English</el-dropdown-item>
					<el-dropdown-item command="fr-CA"><i class="flag-icon flag-icon-fr mr-15"></i>French</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- <button class="fullscreen-button" @click="toggleFullscreen">
				<i class="mdi mdi-fullscreen" v-if="!fullscreen"></i>
				<i class="mdi mdi-fullscreen-exit" v-if="fullscreen"></i>
			</button> -->
			<!-- <el-popover ref="popover" placement="bottom" :width="popoverWidth" trigger="click">
				<notification-box></notification-box>
			</el-popover>
			<el-badge :is-dot="true" class="notification-icon-badge">
				<el-button v-popover:popover icon="mdi mdi-bell" class="notification-icon"></el-button>
			</el-badge> -->
			<!-- <span class="username"> -->
				<!-- <router-link to="/profile">{{getUserName}}</router-link> -->
				<!-- {{getUserName}} -->
			<!-- </span> -->
      <el-dropdown trigger="click" v-if="!isAnonymousAuth">
        <el-dropdown-item>{{portausCompanyName}}</el-dropdown-item>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="isMultiCompany" @click.native="handleSwitchCompany"><i class="mdi mdi-home-switch mr-10"></i>{{ $t('common.changeCompany') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
			<el-dropdown trigger="click" v-if="!isAnonymousAuth">
				<span class="el-dropdown-link">
					<img src="../assets/images/unknown-user3.jpg" class="avatar" alt="avatar">
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item  :disabled="true" class="text-center">{{getUserName}}</el-dropdown-item>
					<el-dropdown-item   @click.native="showUserForm" class="text-left">{{$t('user.profile')}}</el-dropdown-item>
					<el-dropdown-item @click.native="logout" divided><i class="mdi mdi-logout mr-10"></i> Logout</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<button @click="toggleSidebar" v-if="menuBurger === 'right'" class="toggle-sidebar toggle-sidebar__right card-base card-shadow--small">
				<i class="mdi mdi-menu"></i>
			</button>
		</div>
	<userForm :userFormvisible="userFormVisible" type="PROFIL" :defaultTitle="$t('user.profileTitle')" @close="userFormVisible=false" @userModified="userModified" :currentUser="getUserV2"></userForm>
    <SwitchPortausCompanyModal
	   v-if="!isAnonymousAuth"
      :visible="switchCompanyModalVisible"
      @close="handleSwitchCompanyClose"/>
	</div>
</template>

<script>
import NotificationBox from '@/components/NotificationBox'
import SwitchPortausCompanyModal from '@/components/portausCompany/switch-company-modal.vue'
import Search from '@/components/Search'
import userForm from '@/components/users/user-form-component'
import axios from "axios"
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'Toolbar',
	props: ['menuBurger'],
	data() {
		return {
			userFormVisible: false,
			popoverWidth: 300,
			fullscreen: false,
      		switchCompanyModalVisible: false,
		}
	},
	computed : {
		isAdmin(){
			return JSON.parse(localStorage.user).is_admin;
		},
		canChangeAccount(){
			return this.$store.getters.customerProfiles && this.$store.getters.customerProfiles.length>1;
		},
		customerName(){
			if(this.$store.getters.customerProfile){
				return this.$store.getters.customerProfile.name;
			}else{
				return null;
			}
		},
    getCompanyName () {
      return _.get(_.head(this.getCompanies), 'name');
    },
	getUserName(){
		if (this.getUserV2 != null) {
			return `${this.getUserV2.firstName} ${this.getUserV2.lastName}`;
		}
		return "";
		// console.log("localStorage.user : ", localStorage.user);
		// if(localStorage.user!=null){
		// 	var parsedUser = JSON.parse(localStorage.user);
		// 	// console.log("user: ", parsedUser);
		// 	if(parsedUser!=null && parsedUser.first_name!=null && parsedUser.last_name!=null){
		// 		return parsedUser.first_name + " " + parsedUser.last_name;
		// 	}
		// }
		// return "";
	},
	isAnonymousAuth(){
		return this.$store.getters.isAnonymousAuth;
	},
    isMultiCompany () {
      return _.size(_.filter(this.getCompanies, pc => pc.portaus_company_users_role.active === true)) > 1;
    },
    getCompanies () {
      return _.get(this.getUser, 'portausCompanies');;
    },
    getUser () {
      if(localStorage.user!=null){
				var parsedUser = JSON.parse(localStorage.user);
        return parsedUser;
			}
			return null;
    },
	getUserV2 () {
      	if(this.authenticatedUser != null){
			
        	return {
				id: this.authenticatedUser.id,
				firstName: this.authenticatedUser.first_name,
				lastName: this.authenticatedUser.last_name,
				email: this.authenticatedUser.email,
				active: this.authenticatedUser.active,
				webAccess: this.authenticatedUser.web_access,
				roles: this.authenticatedUser.roles,
			}
		}
		return null;
    },
    ...mapGetters(['portausCompanyName', 'authenticatedUser']),
	...mapState(['flag'])
	},
	methods: {
	userModified(){
		this.AUTH_GET_ME();
	},
	showUserForm(){
		this.userFormVisible = true;
	},
    handleSwitchCompanyClose () {
      this.switchCompanyModalVisible = false;
    },
    handleSwitchCompany (){
      this.switchCompanyModalVisible = true;
    },
		logout(){
			this.onCommand('/logout')
		},
		onCommandLang(lang) {
			if(lang.charAt(0) === '/')
				this.onCommand(lang)
			else
				// this.$i18n.locale = lang.substring(0,2);
				// moment.locale(lang);
				// this.axios.defaults.headers.common['accept-language'] = lang;
				// this.flag = lang.substring(0,2);
				// if(this.flag=='en')this.flag='us'
				// this.lang = lang.substring(0,2);
       	 this.changeLocale(lang);

		},
		onCommand(path) {
			this.$router.push(path)
		},
		toggleSidebar() {
			this.$emit('toggle-sidebar')
		},
		resizePopoverWidth() {
			if(window.innerWidth <= 768) {
				this.popoverWidth = 250
			} else {
				this.popoverWidth = 300
			}
		},
		// toggleFullscreen() {
		// 	this.$fullscreen.toggle(document.querySelector('body'), {
		// 		wrap: false,
		// 		callback: () => {this.fullscreen = this.$fullscreen.getState()}
		// 	})
		// }
		...mapActions(['changeLocale','AUTH_GET_ME']),
	},
	components: {
		NotificationBox,
		Search,
    	SwitchPortausCompanyModal,
		userForm,
	},
	mounted() {
		// this.fullscreen = this.$fullscreen.getState()
		this.resizePopoverWidth();
		window.addEventListener('resize', this.resizePopoverWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizePopoverWidth);
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
@import '../assets/scss/_mixins';

.toolbar {
	width: 100%;
	height: 100%;
	padding: 0 20px;
	box-sizing: border-box;

	.username {
		margin-left: 20px;
		font-weight: bold;
		@include text-bordered-shadow();

		a {
			color: $text-color;
			text-decoration: none;

			&:hover {
				color: $text-color-accent;
			}
		}
	}

	.avatar {
		border-radius: 50%;
		width: 35px;
		height: 35px;
		border: 1px solid #FFF;
		margin-left: 20px;
		box-sizing: border-box;
		display: block;
		cursor: pointer;
		box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
		transition: box-shadow .5s;

		&:hover {
			box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08), 0px 2px 7px 0 rgba(0, 0, 0, 0.08);
		}
	}

	.notification-icon {
		font-size: 20px;
		outline: none;
		padding: 0;
		background: transparent;
		border: none;
		margin-left: 20px;
		//color: #aab7c5;
		color: transparentize($text-color, 0.7);
		@include text-bordered-shadow();

		&:hover {
			color: $text-color-accent;
		}
	}

	.toggle-sidebar {
		border: 1px solid transparent;
		height: 32px;
		min-height: 32px;
		line-height: 32px;
		width: 32px;
		min-width: 32px;
		max-width: 32px;
		box-sizing: border-box;
		text-align: center;
		margin: 0;
		outline: none;
		margin-right: 5px;
		font-size: 24px;
		padding: 0;
		cursor: pointer;
		display: inline-block;
		color: $text-color;
		background: white;
		display: none;
		opacity: 0;
		transition: all .5s;

		&__right {
			margin-right: 0px;
			margin-left: 5px;
		}

		&:hover, &:focus, &:active {
			color: $text-color-accent;
			border-color: $text-color-accent;
		}
	}

	.fullscreen-button {
		font-size: 24px;
		cursor: pointer;
		outline: none;
		padding: 0;
		background: transparent;
		border: none;
		margin-left: 20px;
		//color: #aab7c5;
		color: transparentize($text-color, 0.7);
		@include text-bordered-shadow();

		&:hover {
			color: $text-color-accent;
		}
	}

	.el-dropdown {
		.flag-icon {
			box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
			cursor: pointer;
			border: 1px solid lighten($background-color, 20%);
			background-color: lighten($background-color, 20%);
		}
	}
}

@media (max-width: 650px) {
	.toolbar {
		.username {
			display: none;
		}
	}
}

@media (max-width: 768px) {
	.toolbar {
		padding: 0 10px;

		.toggle-sidebar {
			display: block;
			opacity: 1;
		}

		.fullscreen-button {
			display: none;
		}
	}
}
</style>
